/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-20T19:56:10.86
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHouseAirCheckEditInit,
	getRentHouseAirCheckView
} from '@api/rentmanage/RentHouseAirCheck';

import {
listRentHouseAirCheckItemInit,
listRentHouseAirCheckItemByAuthorizations,
deleteRentHouseAirCheckItem
} from '@api/rentmanage/RentHouseAirCheckItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHouseAirCheckEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseAirCheckEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseAirCheckView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseAirCheckView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
